<div class="nav_container" *ngIf="logged == 'true' && profil == 1">
  <div>
    <ul>
      <div class="mb-4">
        <!-- Outils -->
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">
          Outils
        </li>
        <li>
          <a
            [routerLink]="['agenda/apprenant']"
            class="nav_item"
            routerLinkActive="active-link"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path
                fill="#E5E8EC"
                stroke="black"
                stroke-width="6"
                d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z"
              />
            </svg>
            <span class="ml-3">Mon SIGUI</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['users/portfolio']"
            class="nav_item"
            routerLinkActive="active-link"
          >
            <svg
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 19"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="m9 12 5.419 3.871A1 1 0 0 0 16 15.057V2.943a1 1 0 0 0-1.581-.814L9 6m0 6V6m0 6H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h7m-5 6h3v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-5Zm15-3a3 3 0 0 1-3 3V6a3 3 0 0 1 3 3Z"
              />
            </svg>
            <span class="ml-3">Mon portfolio</span>
          </a>
        </li>
      </div>
      <div class="mb-4">
        <!-- PLATEFORME LMS -->
        <li class="uppercase text-greyLighter text-sm font-bold mb-1">
          Plateforme LMS
        </li>
        <!-- Vacance Numerique -->
        <div>
          <ul>
            <li>
              <button
                class="nav_item text-left"
                (click)="openUrl(vcnRoute.VCN)"
              >
                <svg
                  height="24"
                  id="svg8"
                  version="1.1"
                  viewBox="0 0 24 24"
                  width="24"
                >
                  <g
                    id="g1514"
                    style="display: inline"
                    transform="translate(-0.0011279,-290.64853)"
                  >
                    <path
                      fill="#E5E8EC"
                      d="m 2.31126,305.45171 a 1.0001,1.0001 0 0 0 -0.2928,0.71263 l 0.0345,5.48974 a 1.0001,1.0001 0 0 0 1.00697,0.99283 l 5.42206,-0.0359 a 1.0001,1.0001 0 0 0 0.70019,-0.2914 l 11.76119,-11.76119 c 1.38704,-1.387 1.38747,-3.6622 0,-5.04918 l -1.81887,-1.81886 c -1.38708,-1.387 -3.66487,-1.387 -5.05195,-1e-5 z m 1.70976,1.11866 8.09168,-8.09168 4.04099,4.04102 -8.09442,8.09442 -4.01202,0.0262 z m 9.50588,-9.50588 1.95975,-1.95975 c 0.62801,-0.628 1.59549,-0.62798 2.2235,1e-5 l 1.81887,1.81887 c 0.62805,0.62798 0.62768,1.59273 10e-6,2.22075 l -1.96112,1.96112 z"
                    />
                  </g>
                </svg>
                <span>Vacances Citoyennes Numériques</span>
              </button>
            </li>
          </ul>
        </div>
        <!-- Scholar Vox -->
        <!-- <ul *ngIf=" isVCN && !cohorte && !isOffTrackStudent && !coursera_user && !hidden" class="mb-4"> -->
        <!-- <div>
          <ul>
            <li>
              <button
                class="nav_item text-left"
                (click)="openUrl(urlScholarVox)"
              >
                <svg
                  viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg"
                  style="transform: scale(1.1)"
                >
                  <path
                    fill="#E5E8EC"
                    d="M27,4H17V3a1,1,0,0,0-2,0V4H5A3,3,0,0,0,2,7V23a3,3,0,0,0,3,3h6.7l-1.55,2.47a1,1,0,0,0,.32,1.38,1,1,0,0,0,1.38-.32L14.05,26H18l2.2,3.53a1,1,0,0,0,1.38.32,1,1,0,0,0,.32-1.38L20.3,26H27a3,3,0,0,0,3-3V7A3,3,0,0,0,27,4ZM4,7A1,1,0,0,1,5,6H27a1,1,0,0,1,1,1V20H26V19a3,3,0,0,0-3-3H21a3,3,0,0,0-3,3v1H4ZM24,20H20V19a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1Zm4,3a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V22H28Z"
                  />
                </svg>
                <span>Scholar Vox</span>
              </button>
            </li>
          </ul>
        </div> -->
      </div>
    </ul>
  </div>

  <!--  Compte -->
  <div>
    <ul>
      <div class="mb-4">
        <div>
          <li class="uppercase text-greyLighter text-sm font-bold mb-1">
            Compte
          </li>
          <li>
            <a
              [routerLink]="['users/profil']"
              class="nav_item"
              routerLinkActive="active-link"
            >
              <svg
                class="text-greyLighter"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 18"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  d="M7 8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-2 3h4a4 4 0 0 1 4 4v2H1v-2a4 4 0 0 1 4-4Z"
                />
              </svg>
              <span class="ml-3">Mon Profil</span>
            </a>
          </li>
        </div>
      </div>
    </ul>
  </div>
</div>
